export default new class TrainerMethods {
  constructor() {
  }

  commitVal(value, param, method, app) {
    let val = {
      train: method + '_params',
      param_name: param,
      param_val: value
    }
    app.$store.commit('train/changeParam', val);
  }
}